import ModalPortal from '@Components/Popups/ModalPortal'
import React from 'react'
import ConfirmationPopup from '@Components/Popups/ConfirmationPopup'
import Popup from '@Components/Popups/Popup'

interface SaveToDraftModalProps {
    sidebarIsOpen: boolean
    setSidebarIsOpen: (isOpen: boolean) => void
    saveDraftsFromPopup: (saveDrafts: boolean) => void
}
const SaveToDraftModal = (props: SaveToDraftModalProps) => {
    const { sidebarIsOpen, setSidebarIsOpen, saveDraftsFromPopup } = props
    return (
        <ModalPortal isOpen={sidebarIsOpen} onClose={() => setSidebarIsOpen(false)}>
            <Popup onClose={() => setSidebarIsOpen(false)}>
                <ConfirmationPopup
                    onConfirm={() => saveDraftsFromPopup(true)}
                    confirmButtonText="Save to drafts"
                    cancelButtonText="Discard"
                    onCancel={() => saveDraftsFromPopup(false)}
                    title="Would you like to save the incomplete works to drafts?"
                >
                    <p>This will save any incomplete works (works with error) to your drafts.</p>
                </ConfirmationPopup>
            </Popup>
        </ModalPortal>
    )
}
export default SaveToDraftModal
